import get from 'lodash.get';
import React from 'react';
import styled from 'react-emotion';
import Image from '@jetshop/ui/Image/Image';
import theme from '@jetshop/ui/utils/theme';
import {
  StyledBreadcrumbs,
  CategoryName,
  CategoryContent,
  Inner,
} from '../CategoryPage/CategoryHeader';
import CategoryHeaderLoadingState from '../CategoryPage/CategoryHeaderLoadingState';
import MaxWidth from '../Layout/MaxWidth';
import { useScript } from '../../hooks/useScript';

import { Shortcodes } from '@jetshop/flight-shortcodes';
import LongTextImage from '../Shortcodes/LongTextImage';
import Row from '../Shortcodes/Row';
import Column from '../Shortcodes/Column';
import Quote from '../Shortcodes/Quote';
import ShortcodeImage from '../Shortcodes/Image';
import CTA from '../Shortcodes/CTA';
import PageLink from '../Shortcodes/PageLink';
import ProductRow from '../Shortcodes/ProductRow';
import Video from '../Shortcodes/Video';
import FAQ from '../Shortcodes/FAQ';

const CategoryWrapper = styled('div')``;
const CategoryImage = styled('div')``;
const StyledInner = styled(Inner)`
  padding-top: 10px;
  max-width: 1000px;
  margin: 1.5rem auto;

  ${theme('below.md')} {
    margin-top: 0;
    padding-top: 0;
  }

  & > ul:first-of-type {
    justify-content: center;
    padding-bottom: 0.5rem;
  }

  h1 {
    margin-bottom: 25px;
  }
`;
const StyledCategoryContent = styled(CategoryContent)`
  font-family: ${theme('fonts.primary')};
  width: 100%;
  .youtube-embed {
    display: none;
  }

  h1 {
    font-size: 1.75rem;
    letter-spacing: 1px;
    line-height: 1.4;
    margin-bottom: 1.5rem;
  }

  h2 {
    letter-spacing: 1px;
    padding-top: 15px;
  }

  h3 {
    letter-spacing: 1px;
    padding-top: 15px;
  }

  h4 {
    font-size: 1rem;
    letter-spacing: 1px;
  }

  p {
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    justify-content: flex-start;
    width: 100%;
  }

  ul {
    font-size: 0.85rem;
    list-style-type: disc;
    margin-left: 1rem;
  }

  td {
    font-size: 0.85rem;
    strong {
    }
  }

  iframe {
    margin: 1.5rem 0;
  }

  img {
    width: 100%;
    height: 100%;
  }

  a {
    color: ${theme('colors.primary')};
    text-decoration: none;
    transition: all ease 0.3s;
    &:hover {
      color: ${theme('colors.primary')};
      text-decoration: underline;
    }
  }

  ${theme('below.md')} {
    margin: 0;
    width: 100%;
  }
`;

const Category = ({ category, cacheHit }) => {
  const parents = get(category, 'route.parents');
  const breadcrumbProps = {
    breadcrumbText: category.breadcrumbText,
    parents,
  };
  const [loaded, error] = useScript(
    'https://static.businessbike.se/elements/calculator-advanced/sv/bundle.js'
  );

  return (
    <CategoryWrapper>
      <>
        {!cacheHit ? (
          <CategoryHeaderLoadingState />
        ) : (
          <>
            {category.images && category.images.length > 0 ? (
              <CategoryImage>
                <Image
                  src={category.images}
                  quality={80}
                  crop={true}
                  cover={true}
                  gravity="north"
                  aspect={'5:2'}
                  alt={category.name}
                />
              </CategoryImage>
            ) : null}
            <MaxWidth>
              <StyledInner>
                <StyledBreadcrumbs {...breadcrumbProps} />
                <CategoryName data-testid="page-header">
                  {category.name}
                </CategoryName>

                <StyledCategoryContent>
                  <Shortcodes
                    content={category.content}
                    components={{
                      LongTextImage: LongTextImage,
                      Row: Row,
                      Column: Column,
                      Quote: Quote,
                      Image: ShortcodeImage,
                      CTA: CTA,
                      PageLink: PageLink,
                      ProductRow: ProductRow,
                      Video: Video,
                      FAQ: FAQ,
                    }}
                  />
                  {category?.id === 883 && loaded ? (
                    <>
                      <bb-calculator-advanced>
                        BusinessBike Vorteilsrechner
                      </bb-calculator-advanced>
                    </>
                  ) : null}
                </StyledCategoryContent>
              </StyledInner>
            </MaxWidth>
          </>
        )}
      </>
    </CategoryWrapper>
  );
};

export default Category;
